// src/stores/form_store.js
import { defineStore } from 'pinia';

export const useFormStore = defineStore('formStore', {
  state: () => ({
    location: '',
    assetTypes: [],
    buildingUseTypes: [],
    parkingTypes: [],
    yearBuild: [null, null],
    squareFeet: [null, null],
    numberOfUnits: [null, null],
    numberOfFloors: [null, null],
    constructionTypes: [],
    yearPricingLockedIn: [null, null],
    demolition: '',
    abatement: '',
    foundationType: '',
    structuralType: '',
    windowType: '',
    facadeType: '',
    interiorFinishLevel: '',
    escalation: null,
  }),
  actions: {
    setField(field, value) {
      this[field] = value;
    },
    resetForm() {
      this.$reset();
    },
  },
  persist: true,
});